import React from "react";
import { default as MUISwitch } from "@mui/material/Switch";
import styled from "styled-components";

const StyledMUISwitch = styled(MUISwitch)``;

export const Switch = (props) => {
  return <StyledMUISwitch {...props} />;
};
